import PropTypes from 'prop-types';

const FormPropTypes = PropTypes.shape({
  getFieldDecorator: PropTypes.func.isRequired,
  validateFields: PropTypes.func.isRequired,
});

export const Antd = {
  FormPropTypes,
};

export const Address = PropTypes.shape({
  houseNo: PropTypes.string,
  address01: PropTypes.string,
  address02: PropTypes.string,
  town: PropTypes.string,
  country: PropTypes.string,
  postCode: PropTypes.string,
});

export const EmbbedAddress = {
  houseNo: PropTypes.string,
  address01: PropTypes.string,
  address02: PropTypes.string,
  town: PropTypes.string,
  country: PropTypes.string,
  postCode: PropTypes.string,
};
